import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Calendar, Users, Store, Globe, ArrowRight, CreditCard } from "lucide-react";
import { supabase } from "../supabaseClient";

export default function Home() {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function getMiniProfile() {
      const { data: { user } } = await supabase.auth.getUser();
      if (user) {
        const { data } = await supabase
          .from("profiles")
          .select("full_name, points, has_card")
          .eq("user_id", user.id)
          .single();
        setProfile(data);
      }
      setLoading(false);
    }
    getMiniProfile();
  }, []);

  const ownsCard = profile?.has_card === "yes";

  const styles = {
    container: {
      minHeight: "100vh",
      backgroundColor: "#FFFFFF",
      fontFamily: "'Inter', sans-serif",
      color: "#2D302D",
      paddingBottom: "40px",
    },
    header: {
      padding: "2.5rem 1.5rem 1.5rem 1.5rem",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    logoText: {
      fontSize: "1.8rem", 
      fontWeight: "900",
      margin: 0,
      background: "linear-gradient(90deg, #12873B 0%, #2D302D 100%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      letterSpacing: "-0.5px",
    },
    heroCard: {
      background: ownsCard 
        ? "linear-gradient(135deg, #12873B 0%, #2D302D 100%)" 
        : "linear-gradient(135deg, #ff9b31 0%, #de2d05 100%)", 
      margin: "0 1.5rem 2.5rem 1.5rem",
      padding: "2.2rem",
      borderRadius: "32px",
      color: "white",
      boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
      position: "relative",
      overflow: "hidden",
    },
    heroButton: {
      backgroundColor: "white",
      color: ownsCard ? "#12873B" : "#E5243B",
      border: "none",
      padding: "0.9rem 1.5rem",
      borderRadius: "16px",
      fontWeight: "800",
      display: "flex",
      alignItems: "center",
      gap: "8px",
      cursor: "pointer",
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "1.2rem",
      padding: "0 1.5rem",
    },
    navCard: {
      backgroundColor: "#F8FAFB",
      padding: "1.8rem 1rem",
      borderRadius: "28px",
      textDecoration: "none",
      color: "#2D302D",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: "12px",
      border: "1px solid #E2E8F0",
    },
    iconCircle: {
      width: "48px",
      height: "48px",
      borderRadius: "14px",
      backgroundColor: "#D1EAD9",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#12873B",
    }
  };

  if (loading) return null;

  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <h2 style={styles.logoText}>
         
        </h2>
      </header>

      <div style={styles.heroCard}>
        <div style={{ position: "relative", zIndex: 2 }}>
          {ownsCard ? (
            <>
              <h1 style={{ fontSize: "1.8rem", margin: "0 0 0.5rem 0", fontWeight: "800" }}>
                Welcome Back!
              </h1>
              <p style={{ opacity: 0.9, fontSize: "0.95rem", marginBottom: "1.8rem" }}>
                Active Card • <strong>{profile?.points || 0} points</strong>
              </p>
              <Link to="/partners" style={{ textDecoration: "none" }}>
                <button style={styles.heroButton}>
                  Earn Points <ArrowRight size={18} />
                </button>
              </Link>
            </>
          ) : (
            <>
              <h1 style={{ fontSize: "1.8rem", margin: "0 0 0.5rem 0", fontWeight: "800" }}>
                Welcome!
              </h1>
              <p style={{ opacity: 0.9, fontSize: "0.95rem", marginBottom: "1.8rem" }}>
                Unlock exclusive deals and start tracking your impact.
              </p>
              <Link to="/get-card" style={{ textDecoration: "none" }}>
                <button style={styles.heroButton}>
                  Buy My Card <CreditCard size={18} />
                </button>
              </Link>
            </>
          )}
        </div>
        <div style={{ position: "absolute", bottom: "-20px", right: "-20px", width: "150px", height: "150px", borderRadius: "50%", background: "rgba(255,255,255,0.12)" }} />
      </div>

      <h3 style={{ fontSize: "1.2rem", fontWeight: "800", margin: "0 1.5rem 1.2rem 1.5rem", color: "#12873B" }}>
        Explore
      </h3>

      <div style={styles.grid}>
        <Link to="/sdgs" style={styles.navCard}>
          <div style={styles.iconCircle}><Globe size={26} /></div>
          <span style={{ fontWeight: "700", fontSize: "0.95rem" }}>SDGs</span>
        </Link>
        
        <Link to="/partners" style={styles.navCard}>
          <div style={styles.iconCircle}><Store size={26} /></div>
          <span style={{ fontWeight: "700", fontSize: "0.95rem" }}>Partners</span>
        </Link>

        <Link to="/leaderboard" style={styles.navCard}>
          <div style={styles.iconCircle}><Users size={26} /></div>
          <span style={{ fontWeight: "700", fontSize: "0.95rem" }}>Ranking</span>
        </Link>

        <Link to="/calendar" style={styles.navCard}>
          <div style={styles.iconCircle}><Calendar size={26} /></div>
          <span style={{ fontWeight: "700", fontSize: "0.95rem", textAlign: "center" }}>Events Calendar</span>
        </Link>
      </div>
    </div>
  );
}